export default __webpack_public_path__ + "static/media/tickGreen.597cc5c9.svg";